import { useQuery } from '@apollo/client/react';
import { GET_TODOS } from '../graphql/queries';
import { ToDoRowModel } from '../../components/Table/ToDoTable/entities/Entities';
import { getToDosArbeitszeiten } from './getToDosArbeitszeiten';
import { getToDoAntraege } from './getToDosAntraege';
import { getToDosKonflikte } from './getToDosKonflikte';

export type UseToDosResult = {
  toDos: ToDoRowModel[];
  error?: Error | undefined;
  loading: boolean;
};

export function useToDos(Datum: string, standortId: string): UseToDosResult {
  const { data, error, loading } = useQuery(GET_TODOS, {
    variables: { Datum, standortId },
    fetchPolicy: 'no-cache',
  });

  const toDosArbeitszeiten = data ? getToDosArbeitszeiten({ data }) : [];
  const toDosAntraege = data ? getToDoAntraege({ data }) : [];
  const toDosKonflikte = data ? getToDosKonflikte({ data }) : [];

  return {
    toDos: [...toDosArbeitszeiten, ...toDosKonflikte, ...toDosAntraege],
    error,
    loading,
  };
}
